// extracted by mini-css-extract-plugin
export var divider = "_fx-7";
export var itemsToggle = "_fx-8";
export var mergeModal = "_fx-1";
export var optionCard = "_fx-4";
export var radioGroup = "_fx-6";
export var radioOption = "_fx-0";
export var selected = "_fx-5";
export var shipmentOptions = "_fx-2";
export var tableOptions = "_fx-3";